import React, { Component, useEffect, useState } from "react";
import ComponentTopupTutorialMobile from "./ComponentTopupTutorialMobile";
import ComponentTopupTutorialWeb from "./ComponentTopupTutorialWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentTopupTutorial = () => {
  const gaEventTracker = useAnalyticsEventTracker("TopupTutorial");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Top Up Tutorial",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentTopupTutorialWeb></ComponentTopupTutorialWeb>
      </BrowserView>
      <MobileView>
        <ComponentTopupTutorialMobile></ComponentTopupTutorialMobile>
      </MobileView>
    </>
  );
};

export default ComponentTopupTutorial;
